import React, { useEffect, useState } from 'react';
import messages from '../../../messages';
import { updateCompany } from '../../API/company';
import { getSellerData } from '../../API/amazonKeepa';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useCompanyContext } from '../../../contexts/Company';
import ConnectAmazonAccount from '../accounts/ConnectAmazonAccount';
import { getAmazonSellerAccounts } from '../../API';
import { pathname } from 'frontend/src/utils';
import FinishedPreQualify from './FinishedPreQualify';
import { useEventTrackerContext } from 'frontend/src/contexts';
import { useQuery } from 'frontend/src/hooks/useQuery';
import { useHistory } from 'react-router-dom';

export default function AmazonConnect({ setSwitchToSellerId }) {
  const { setLoading, goForward, setActiveStep } = useOnboardingContext();
  const { business, setBusiness } = useCompanyContext();
  const snackbar = useSnackbarContext();
  const { trackEvent } = useEventTrackerContext();
  const [amzAccounts, setAmzAccounts] = useState(null);
  const [finishedPreQualifySteps, setFinishedPreQualifySteps] = useState(false);
  const query = useQuery();
  const demoSellerId = query.get('demoConnect');
  const history = useHistory();

  async function getAmazonSellerAccountsWrapper() {
    try {
      setLoading(true);
      const amzAccounts = (await getAmazonSellerAccounts()).filter(
        (account) => account.connected,
      );
      setAmzAccounts(amzAccounts);
      if (amzAccounts.length > 0 || demoSellerId) {
        await updateSellerData(demoSellerId || amzAccounts[0].sellerId, true);
      }
    } catch (error) {
      snackbar.show(messages.general.saveError, 'error');
      setAmzAccounts([]);
    } finally {
      setLoading(false);
    }
  }

  async function updateSellerData(
    sellerId: string,
    withProducts: boolean = false,
  ) {
    const storeUrl = `https://www.amazon.com/s?me=${business.sellerId}`;
    const updateData = {
      seller_id: sellerId,
      store_url: storeUrl,
    };

    const sellerName = await generateAmzSellerData(sellerId, withProducts);
    if (sellerName) {
      updateData['name'] = sellerName;
    }

    await updateCompany(updateData);

    trackEvent({ event: 'entered_store_url', store_url: storeUrl });

    setBusiness({
      ...business,
      sellerId: sellerId,
      name: sellerName,
      store_url: storeUrl,
    });
  }

  useEffect(() => {
    getAmazonSellerAccountsWrapper();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setActiveStep(pathname.onboarding.main.sellerId.stepInStepper);
  }, [setActiveStep]);

  async function generateAmzSellerData(
    sellerId: string,
    withProducts: boolean = false,
  ) {
    // IF FAIL, FAILS SILENTLY
    let sellerName = null;
    try {
      const seller = await getSellerData(sellerId, withProducts);
      sellerName = seller.sellerName;
    } catch (error) {
      console.log('Error retrieving seller data', error);
    }
    return sellerName;
  }

  useEffect(() => {
    if (!finishedPreQualifySteps) return;
    setTimeout(async () => {
      goForward();
    }, 5500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finishedPreQualifySteps]);

  const handleSubmitAmazonConnect = () => {
    if (demoSellerId) {
      history.replace(pathname.onboarding.main.sellerId.url);
      setFinishedPreQualifySteps(true);
    } else if (amzAccounts.length > 0) {
      setFinishedPreQualifySteps(true);
    } else {
      setSwitchToSellerId(true);
    }
  };

  return finishedPreQualifySteps ? (
    <FinishedPreQualify />
  ) : (
    amzAccounts && (
      <ConnectAmazonAccount
        amzAccounts={amzAccounts}
        business={business}
        lines={[]}
        goForward={handleSubmitAmazonConnect}
      />
    )
  );
}
